<template>
  <div>
    <EditOfferAction
      v-if="canEdit"
      class="float-right"
      :currentOffer="currentOffer"
    />
    <h3 class="pb-1">Salary</h3>
    <p>{{ currentOffer.salary | cost | currency(currencyCode) }}</p>
    <h3 class="pb-1">Proposed Start Date</h3>
    <p>{{ currentOffer.startDate | longDate }}</p>
    <div v-if="document">
      <div class="worker__profile--cv">
        <h5>Document</h5>
        <v-btn text color="primary" @click="handleViewDocument">
          Full-Screen
          <v-icon class="ml-3">mdi-fullscreen</v-icon>
        </v-btn>
      </div>
      <embed class="document" type="application/pdf" :src="document.url" />
      <PDFViewFull :data="documentDialog" />
    </div>
    <div class="d-flex">
      <h3 class="pb-1">References</h3>
      <v-divider class="my-2 ml-2" />
      <!-- TO BE ADDED  reference requirements when api is ready -->
    </div>
  </div>
</template>

<script>
import PDFViewFull from "@/components/common/PDFViewFull";
import EditOfferAction from "@/views/offers/actions/EditOfferAction";
import { isPermissioned } from "@/utils/permissions";

export default {
  props: {
    currentOffer: {
      type: Object,
      required: true
    }
  },
  components: { PDFViewFull, EditOfferAction },
  data() {
    return {
      documentDialog: { dialog: false }
    };
  },
  computed: {
    document() {
      return this.currentOffer.document;
    },
    currencyCode() {
      return "GBP";
    },
    canEdit() {
      return isPermissioned(`offers.edit`);
    }
  },
  methods: {
    handleViewDocument() {
      this.documentDialog.src = this.document.url;
      this.documentDialog.title = "Document";
      this.documentDialog.dialog = true;
    }
  }
};
</script>

<style lang="scss"></style>
